import axios from "axios";
import { apiEndpointFunction } from "@iso/lib/helpers/endpoint";
import { authHeader } from "@iso/lib/helpers/authHeader";

export const sprayJobService = {
  prepare,
};

function prepare(jobId) {
  return axios
    .post(
      apiEndpointFunction.sprayJobs(jobId) + "/prepare",
      {},
      {
        headers: authHeader(),
      }
    )
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
      return { code: 'error', message: 'Unexpected response status' };
    })
    .catch((error) => {
      console.error("Error preparing spray job:", error);
      throw error;
    });
}
